import { Injectable } from '@angular/core';
import { UserUtil } from '../utils/user.utils';
import { SchoolDto } from '../models/dto/school.dto';

@Injectable()
export class SelectUserSchoolService {

  constructor(
    private readonly userUtil: UserUtil,
  ) { }

  getUserSchools(): SchoolDto[] {
    const user = this.userUtil.getUser();
    return user.schools;
  }

  async selectUserSchool(school: SchoolDto): Promise<void> {
    this.userUtil.addUserSelectedSchool(school);
  }
}
